export default "__VITE_ASSET__CGKoRVoQ__"